/**
 * @generated SignedSource<<c636e51b59fb539e368961128f607bde>>
 * @relayHash b6049b445825365ddab1e4c53fe645b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e5885f319bdb44acd258139bdd3bf49e62421b9eea5c5941f6ce559adf0e60c1

import type { ConcreteRequest } from 'relay-runtime';
export type useMauiMoveTopLevelMutation$variables = {
  pageId: string;
  spaceKey: string;
};
export type useMauiMoveTopLevelMutation$data = {
  readonly movePageTopLevel: {
    readonly page: {
      readonly id: string | null | undefined;
      readonly links: {
        readonly editui: string | null | undefined;
        readonly webui: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useMauiMoveTopLevelMutation = {
  response: useMauiMoveTopLevelMutation$data;
  variables: useMauiMoveTopLevelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
          },
          {
            "kind": "Variable",
            "name": "targetSpaceKey",
            "variableName": "spaceKey"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MovePagePayload",
    "kind": "LinkedField",
    "name": "movePageTopLevel",
    "plural": false,
    "selections": [
      {
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "Map_LinkType_String",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "webui"
              },
              {
                "kind": "ScalarField",
                "name": "editui"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useMauiMoveTopLevelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMauiMoveTopLevelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6049b445825365ddab1e4c53fe645b5",
    "id": "e5885f319bdb44acd258139bdd3bf49e62421b9eea5c5941f6ce559adf0e60c1",
    "metadata": {},
    "name": "useMauiMoveTopLevelMutation",
    "operationKind": "mutation",
    "text": "mutation useMauiMoveTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id,links{webui,editui}}}}"
  }
};
})();

(node as any).hash = "40a91a5003b294a2f81375f46e2a6f63";

export default node;
